module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_cinemas.cd98673f.png";